import { type TextFieldProps } from "@sapphire-react/core";
import { Controller } from "react-hook-form";
import type { FormFieldProps } from "../../types";
import { MaskedNumberField } from "./MaskedNumberField";

type Props = Omit<TextFieldProps, "name"> & {
  name: string;
  min?: number;
  max?: number;
  type?: "number" | "string";
} & FormFieldProps;

export function AmountInputField(props: Props) {
  const {
    control,
    name,
    rules,
    type,
    label,
    defaultValue,
    onChange,
    note,
    error: err,
    ...rest
  } = props;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { ref: _ref, onChange: _onChange, value, ...field },
        fieldState: { error },
      }) => (
        <MaskedNumberField
          type={type}
          label={label}
          defaultValue={defaultValue}
          note={note}
          {...field}
          {...rest}
          value={value}
          error={error?.message || err}
          onChange={(value) => {
            _onChange(value);
            onChange?.(value);
          }}
        />
      )}
    />
  );
}
